import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Course } from '../models/course.model';
import { Tag } from '../models/tag.model';
import { CourseService } from '../services/course.service';
import { TagService } from '../services/tag.service';

@Component({
    selector: 'course-card',
    templateUrl: './course-card.component.html',
    styleUrls: ['./course-card.component.scss']
})

export class CourseCardComponent implements OnInit {

    @Input() course: Course
    @Input() showAllCourses: boolean = true;
    @Input() isPreReq: boolean = false;
    @Input() isRecommended: boolean = false;
    @Input() isUnlocked: boolean = false;

    //@Output() onDetailClicked = new EventEmitter<Course>();
    @Output() onCardExpanded = new EventEmitter<Course>();

    constructor(
       private courseService: CourseService,
       private tagService: TagService,
       private router: Router
        ) {
    }

    ngOnInit() {
    }

    get getRelevancyClass(): string{
        let relevancyClass = "";

        switch (this.course.relevancy){
            case 0:
                relevancyClass = "relevancy-none";
                break;
            case 1:
                relevancyClass = "relevancy-single";
                break;
            default:
                relevancyClass = "relevancy-multi";
                break;
        }
        return relevancyClass;
    }

    get getAdditionalClasses(): string{
        let additionalClasses = "";
        
        if(this.course.courseOpen || !this.showAllCourses){
            additionalClasses += "expanded";
        } else{
            additionalClasses += "collapsed";
        }

        if(this.showAllCourses){
            additionalClasses += " all-courses ";
        } else{
            additionalClasses += " tagged-courses ";
        }

        return additionalClasses;
    }

    courseDetailClicked(): void{
        this.router.navigate(['/course-detail', this.course.id]);
    }

    toggleCourse(): void{
        this.course.courseOpen = true;

         // emit event for course component to pick up, so we can properly check for course prerequisites or recommended course
        this.onCardExpanded.emit(this.course);

        if(this.showAllCourses){
            this.courseService.toggleCourses(this.course);
        } 
    }
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/course-card/course-card.component.ts